import React, { Fragment } from 'react';

import {
  Button,
  Label,
  Text,
  Tooltip,
  Divider,
  Icon,
  Subheading,
  Dropdown,
  InlineMessage,
  PlaceholderParagraph
} from '@innovaccer/design-system';
import classes from './styles.module.css';

const getDropdownOptions = (options, selected) => {
  return options.map((option) => ({ label: option, value: option, selected: option == selected }));
};

function ReviewUpdateDetails(props) {
  const {
    standardETLVersions,
    standardETLVersionDetails: {
      data: { coRelatedEntities, releaseHighlights },
      loading,
      error
    },
    selectedVersion,
    handleVersionChange
  } = props;

  return (
    <div className="py-4">
      <div className="w-100 my-6">
        <Subheading className="mb-4">New Version</Subheading>
        <div>
          <Label withInput={true}>Available versions</Label>
          <div className="w-50">
            <Dropdown
              data-test="standardETL-version"
              key={standardETLVersions.data.length}
              loading={standardETLVersions.loading}
              options={getDropdownOptions(standardETLVersions.data)}
              onChange={handleVersionChange}
            />
          </div>
          <div className="w-50 mt-3">
            <Text appearance="subtle">
              Select from the list consisting of versions released after the one deployed on this environment.
            </Text>
          </div>
        </div>
      </div>
      {!standardETLVersions.loading && !standardETLVersions.error && selectedVersion && (
        <Fragment>
          <Divider />
          <div className="my-6">
            <div className="d-flex flex-row align-items-center justify-content-between mb-5">
              <Subheading>Release Highlights</Subheading>
              <div>
                <Tooltip tooltip="To view release highlights for all the versions, click here.">
                  <Button
                    data-testid="All-version-details"
                    icon="open_in_new"
                    iconAlign="right"
                    onClick={() => window.open(props.releaseUrl, '_open')}
                  >
                    All version details
                  </Button>
                </Tooltip>
              </div>
            </div>
            <div>
              {loading && !error && (
                <Fragment>
                  <PlaceholderParagraph length="medium" size="xxl" />
                  <PlaceholderParagraph length="small" size="xxl" />
                </Fragment>
              )}
              {!loading && !error && (
                <Fragment>
                  <div>
                    <ul className={classes.highlightsWrapperCss}>
                      {releaseHighlights.map((item) => {
                        return (
                          <li className={classes.releaseItemCss}>
                            <Text appearance="subtle" className="ml-4">
                              {item}
                            </Text>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
          <Divider />
          <div className="my-6">
            <Subheading>co-related entities</Subheading>
            <div className="mt-4">
              {loading && !error && (
                <Fragment>
                  <PlaceholderParagraph length="medium" size="xxl" />
                  <PlaceholderParagraph length="small" size="xxl" />
                </Fragment>
              )}
              {!loading && !error && (
                <Fragment>
                  <Text appearance="subtle">L3 Schema</Text>
                  <div className="d-flex flex-row align-items-center ">
                    <Label className="mr-6 mt-3">{coRelatedEntities.l3Schema.version}</Label>
                    <div className="d-flex flex-row align-items-center">
                      <Icon
                        name={coRelatedEntities.l3Schema.isCompatible ? 'check_circle' : 'error'}
                        appearance={coRelatedEntities.l3Schema.isCompatible ? 'success' : 'alert'}
                      />
                      <Text
                        className="ml-3"
                        size="small"
                        color={coRelatedEntities.l3Schema.isCompatible ? 'success' : 'alert'}
                      >
                        {coRelatedEntities.l3Schema.isCompatible ? 'Compatible' : 'Not compatible'}
                      </Text>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            <div className="mt-6">
              {loading && !error && (
                <Fragment>
                  <PlaceholderParagraph length="medium" size="xxl" />
                  <PlaceholderParagraph length="small" size="xxl" />
                </Fragment>
              )}
              {!loading && !error && (
                <Fragment>
                  <Text appearance="subtle">L5 Schema</Text>
                  <div className="d-flex flex-row align-items-center ">
                    <Label className="mr-6 mt-3">{coRelatedEntities.l5Schema.version}</Label>
                    <div className="d-flex flex-row align-items-center">
                      <Icon
                        name={coRelatedEntities.l5Schema.isCompatible ? 'check_circle' : 'error'}
                        appearance={coRelatedEntities.l5Schema.isCompatible ? 'success' : 'alert'}
                      />
                      <Text
                        className="ml-3"
                        size="small"
                        color={coRelatedEntities.l5Schema.isCompatible ? 'success' : 'alert'}
                      >
                        {coRelatedEntities.l5Schema.isCompatible ? 'Compatible' : 'Not compatible'}
                      </Text>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            {!loading && !error && (
              <div className="mt-7">
                <Text appearance="subtle" className="d-block mb-3">
                  Dashboards
                </Text>
                <InlineMessage
                  appearance="warning"
                  description="Please review the compatibility of dashboards to prevent potential failures, before proceeding with the first workflow execution post standard ETL upgrade."
                />
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default ReviewUpdateDetails;
